import { useState } from 'react';
import { Button, Dropdown, Space, MenuProps } from 'antd';
import { DownOutlined, AppstoreOutlined, UnorderedListOutlined } from '@ant-design/icons';
import './MapPortalHeader.scss';

interface MapPortalHeaderProps {
  title: string;
  isMapView: boolean;
  onChange: (isMapView: boolean) => void;
  onSortChange: (sortBy: string) => void;
}

const items: MenuProps['items'] = [
  { label: 'Most Recent', key: '1' },
  { label: 'Map Title', key: '2' },
  { label: 'Creator', key: '3' },
];

const MapPortalHeader: React.FC<MapPortalHeaderProps> = ({ title, onChange, isMapView, onSortChange }) => {
  const [dropDownText, setDropDownText] = useState('Most Recent');

  const handleMenuClick: MenuProps['onClick'] = (e) => {
    const selected = (items as any).find((i: any) => i?.key === e.key)?.label;
    if (selected) {
      setDropDownText(selected);
      onSortChange(selected);
    }
  };

  return (
    <div className="mp-header">
      <h1 className="mp-header__title">{title}</h1>
      <div className="mp-header__toolbar">
        <Dropdown menu={{ items, onClick: handleMenuClick }}>
          <Button className="mp-header__sort">
            <Space>
              {dropDownText}
              <DownOutlined />
            </Space>
          </Button>
        </Dropdown>

        <div className="mp-header__views">
          <button type="button" className={`mp-header__view${!isMapView ? ' is-active' : ''}`} onClick={() => onChange(false)} aria-label="List view">
            <UnorderedListOutlined />
          </button>
          <button type="button" className={`mp-header__view${isMapView ? ' is-active' : ''}`} onClick={() => onChange(true)} aria-label="Grid view">
            <AppstoreOutlined />
          </button>
        </div>
      </div>
    </div>
  );
};

export default MapPortalHeader;
